import React, { useEffect, useState } from 'react';
import { Descriptions, Divider, Image, Tag, Checkbox, Skeleton } from "antd";
import { MDBCol } from "mdbreact";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";

const moment = require("moment");

const ViewGroup = (props) => {
	var db = getDatabase(Firebase);
	const [users, usersLoading] = useListVals(ref(db, "talmidsdb/users"));
	const [districtArray, districtsLoading] = useListVals(ref(db, "talmidsdb/district"));
	const [communityArray, communitiesLoading] = useListVals(ref(db, "talmidsdb/communities"));
	const [orgArray, orgsLoading] = useListVals(ref(db, "talmidsdb/organisations"));
	const [countries, countriesLoading] = useListVals(ref(db, "talmidsdb/countries"));
	const [groupTypes, groupTypesLoading] = useListVals(ref(db, "talmidsdb/groupTypes"));
	const marketDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	const [languageArray] = useState([]);
	const [checkTypeList, setCheckTypeList] = useState([]);

	useEffect(() => {
		const filteredOptions = groupTypes.filter(x => x.typeID !== props.group?.groupType);
		filteredOptions.map((item, index) => {
			filteredOptions[index]["label"] = item.type;
			filteredOptions[index]["value"] = item.typeID;
		});
		setCheckTypeList([...filteredOptions]);
	}, [groupTypes, props.group]);

	const isLookupLoading =
		usersLoading ||
		districtsLoading ||
		communitiesLoading ||
		orgsLoading ||
		countriesLoading ||
		groupTypesLoading;

	// Helper functions to get display values
	const getUserName = (userId) => {
		const user = users?.find(u => u.id === userId);
		return user ? `${user.firstname} ${user.surname}` : userId;
	};

	const getDisplayValue = (value, options, idKey = 'id', labelKey = 'name') => {
		if (!value) return '-';
		if (Array.isArray(value)) {
			return value.map(v => {
				const option = options?.find(o => o[idKey] === v);
				return option ? option[labelKey] : v;
			}).join(', ');
		}
		const option = options?.find(o => o[idKey] === value);
		return option ? option[labelKey] : value;
	};

	const formatDate = (date) => {
		return date ? moment(date).format("YYYY MMM DD HH:mm") : '-';
	};

	if (isLookupLoading) {
		return <Skeleton active paragraph={{ rows: 12 }} />;
	}

	return (
		<MDBCol md={12}>
			<div className="group-view-container">
				<div className="group-photos">
					<Image.PreviewGroup>
						{props.group?.photos?.map((photo, index) => (
							<Image
								key={index}
								src={photo}
								width={200}
								className="p-2"
								alt={`Group photo ${index + 1}`}
							/>
						))}
					</Image.PreviewGroup>
				</div>
				<Descriptions bordered column={1} size="small">
					<Descriptions.Item label="Group Name">{props.group?.groupSelfName || '-'}</Descriptions.Item>
					<Descriptions.Item label="Country">
						{getDisplayValue(props.group?.countryID, countries, 'id', 'countryName')}
					</Descriptions.Item>
					<Descriptions.Item label="Organization">
						{getDisplayValue(props.group?.orgID, orgArray, 'id', 'name')}
					</Descriptions.Item>
					<Descriptions.Item label="District">
						{getDisplayValue(props.group?.districtID, districtArray, 'id', 'districtName')}
					</Descriptions.Item>
					<Descriptions.Item label="Community">
						{getDisplayValue(props.group?.communityID, communityArray, 'id', 'name')}
					</Descriptions.Item>
					<Descriptions.Item label="Group Type">
						{getDisplayValue(props.group?.groupTypeId, groupTypes, 'id', 'typeName')}
					</Descriptions.Item>
					<Descriptions.Item label="Secondary Group Activities">
						{checkTypeList
							.filter(item => props.group?.secondaryGroupActivities?.includes(item.value))
							.map(item => item.label)
							.join(', ') || '-'}
					</Descriptions.Item>
					<Descriptions.Item label="Gender Demographics">{props.group?.genderDemographics || '-'}</Descriptions.Item>
					<Descriptions.Item label="What does the group call itself?">
						{props.group?.groupCallsSelf || '-'}
					</Descriptions.Item>
					<Descriptions.Item label="Responsible User">
						{getUserName(props.group?.responsibleUser)}
					</Descriptions.Item>
					<Descriptions.Item label="Year established">
						{props.group?.groupStartDate ? moment(props.group.groupStartDate, "YYYY").format("YYYY") : '-'}
					</Descriptions.Item>
					<Descriptions.Item label="Group End Date (If no longer active)">
						{props.group?.groupEndDate ? moment(props.group.groupEndDate, "YYYY-MM-DD").format("YYYY MMM DD") : '-'}
					</Descriptions.Item>
					<Descriptions.Item label="Group Primary Language">
						{getDisplayValue(props.group?.groupPrimaryLanguage, languageArray, 'languageID', 'languageName')}
					</Descriptions.Item>
					<Descriptions.Item label="Group Purpose Objective">
						{props.group?.groupPurposeObjective || '-'}
					</Descriptions.Item>
					<Descriptions.Item label="Active Men">{props.group?.activeMen || '0'}</Descriptions.Item>
					<Descriptions.Item label="Active Women">{props.group?.activeWomen || '0'}</Descriptions.Item>
					<Descriptions.Item label="Active Disabled">{props.group?.activeDisables || '0'}</Descriptions.Item>
					<Descriptions.Item label="Group Meeting Days">
						{props.group?.meetingDays || '-'}
					</Descriptions.Item>
					<Descriptions.Item label="Has Completed ByLaws">
						<Tag color={props.group?.hasCompletedByLaws === "Yes" ? "green" : "red"}>
							{props.group?.hasCompletedByLaws || "No"}
						</Tag>
					</Descriptions.Item>
					<Descriptions.Item label="Group Status">
						<Tag color={props.group?.groupStatus === "Active" ? "green" :
							props.group?.groupStatus === "Inactive" ? "orange" : "red"}>
							{props.group?.groupStatus || '-'}
						</Tag>
					</Descriptions.Item>
					<Descriptions.Item label="Market Day">
						{Array.isArray(props.group?.marketDay) ? props.group.marketDay.join(', ') : props.group?.marketDay || '-'}
					</Descriptions.Item>
					<Descriptions.Item label="Notes">{props.group?.notes || '-'}</Descriptions.Item>
					<Descriptions.Item label="Salesforce ID">{props.group?.salesforceID || '-'}</Descriptions.Item>
					<Divider orientation="left">Primary Contact Section</Divider>
					<Descriptions.Item label="Primary Contact Name">
						{getUserName(props.group?.primaryContactName)}
					</Descriptions.Item>
					<Descriptions.Item label="Secondary Contact Name">
						{getUserName(props.group?.secondaryContactName)}
					</Descriptions.Item>
					<Descriptions.Item label="Added By">
						{getUserName(props.group?.addedByUser)}
					</Descriptions.Item>
					<Descriptions.Item label="Date Added">
						{formatDate(props.group?.dateCreated)}
					</Descriptions.Item>
					<Descriptions.Item label="Date Modified">
						{formatDate(props.group?.dateModified)}
					</Descriptions.Item>
				</Descriptions>
			</div>
		</MDBCol>
	);
};

export default ViewGroup;
